@use 'src/styles/config.module' as *;

$drawer-width-close: 8rem;
$drawer-width-open: 32rem;

.wrap {
  width: $drawer-width-close;
  transition: 0.3s;
}

.opened,
.hover {
  width: $drawer-width-open;

  .paper {
    width: $drawer-width-open;
    background-color: #fff;
    background-image: url('../../../../images/bg-paper.png');
  }
}

.paper {
  display: grid !important;
  grid-template-rows: auto 1fr auto;
  width: $drawer-width-close;
  transition: 0.3s !important;
  background: none;
  background-position: 50% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  border: none;

  &::before {
    display: block;
    content: '';
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    width: 6.4rem;
    bottom: 0.8rem;
    border-radius: 0.4rem;
    background: $color-primary;
  }
}

.header {
  padding: 0.8rem;
  display: grid;
  grid-template-columns: 6.4rem 1fr;
  grid-template-areas: 'control logo' 'user user';
  grid-gap: 1.2rem 2.5rem;
  margin: 0 0 2.4rem;
}

.control {
  grid-area: control;
  color: #fff;
  height: 6.4rem;
  display: grid;
  align-items: center;
  justify-content: center;
}

.logo {
  grid-area: logo;
  //width: 12.1rem;
  //height: 6.4rem;
  display: flex;
  align-items: center;
  img {
    display: block;
    max-width: 16.5rem;
    height: auto;
  }
}

.user {
  grid-area: user;
  margin: 0 -0.8rem 0 0;

  :global {
    .user-nav {
      width: calc(32rem - 0.8rem);
      .user-button {
        padding-right: 1.6rem;
      }

      .position {
        color: $color-grey;
        font-size: 1.2rem;
        font-weight: normal;
      }

      .MuiButton-startIcon {
        flex: 0 0 6.4rem;
        justify-content: center;
        margin-right: 2.5rem;
        margin-left: 0;

        svg {
          font-size: 4rem !important;
          color: $color-grey-light !important;
          border-radius: 50%;
          background: #fff;
        }
      }

      .avatar {
        height: 4rem !important;
        width: 4rem !important;
        border: 0.2rem solid #fff;
        border-radius: 50%;
        margin: 0 auto;
      }

      .MuiButton-endIcon {
        svg {
          color: $color-grey;
          font-size: 1.6rem;
        }
      }
    }
  }
}

.navigation {
  padding-left: 0.8rem;
  overflow: hidden;

  :global {
    .main-nav {
      overflow: hidden;

      .MuiList-root {
        width: $drawer-width-open - 0.8rem;
      }
      .icon-collapsed {
        font-size: 1.6rem;
        color: $color-grey;
      }

      .active {
        background: none;

        .title {
          .MuiListItemText-primary {
            color: $color-primary !important;
            font-weight: normal !important;
          }
        }

        .icon-wrapper {
          svg {
            opacity: 1;
            color: #fff;
          }
        }
      }

      .icon-wrapper {
        flex: 0 0 6.4rem;
        margin-right: 2.5rem;

        svg {
          transition: transform 0.25s ease-in-out;
          color: #fff;
          opacity: 0.5;
        }
      }

      .MuiList-root {
        .MuiList-root {
          padding: 0.8rem 0.8rem 0.8rem 7.2rem;
        }
      }

      .level-1 {
        min-height: 5rem;
        position: relative;
        padding: 0.6rem 1.6rem 0.6rem 0;

        .MuiListItemText-multiline {
          margin: 0;
        }

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 8.8rem;
          right: 0;
          height: 1px;
          background: $color-border;
        }

        &:last-child {
          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 8.8rem;
            right: 0;
            height: 1px;
            background: $color-border;
          }
        }

        .title {
          .MuiListItemText-primary {
            font-weight: 400;
            text-transform: uppercase;
            font-size: 1.4rem;
            line-height: 1.4;
            color: $color-default;
          }

          .MuiListItemText-secondary {
            font-size: 1.2rem;
            font-weight: normal;
            color: $color-grey;
            opacity: 1;
            line-height: 1.43;
          }
        }
      }

      .level-2 {
        border-radius: 0.4rem;
        padding: 0.5rem 1.6rem;

        .title {
          padding-left: 0;
          margin-top: 0;
          margin-bottom: 0;

          .MuiListItemText-primary {
            font-size: 1.3rem;
            color: $color-default;
          }
        }

        &.active {
          background: rgba($color-grey-light, 0.5);
        }
      }
    }
  }
}
.footer {
  padding: 0.8rem 0.8rem 2.2rem;
  display: grid;
  grid-template-columns: 6.4rem 1fr;
  grid-gap: 0 2.5rem;
  align-items: end;
}

.language {
  padding: 0 0.8rem;
}
.copyright {
  color: $color-grey;
  font-size: 1.2rem;
  padding: 0 0 0.2rem;
}
